import { TreeNode } from '../types/interfaces';

export function limitTreeDepth(
  nodes: TreeNode[],
  level: number = 1
): TreeNode[] {
  if (!Array.isArray(nodes)) {
    console.error('Invalid nodes structure:', nodes);
    return []; // Return an empty array or handle the error as needed
  }

  return nodes.map((node) => ({
    ...node,
    children:
      node.children && level > 1 ? limitTreeDepth(node.children, level - 1) : []
  }));
}
